import "@viivue/easy-tab-accordion";
document.addEventListener("DOMContentLoaded", () => {
  let blocks = document.querySelectorAll("[data-eta-accordion]");

  blocks.forEach((block) => {
    const id = block.getAttribute("data-accordion");

    const cards = block.querySelectorAll("[data-accordion-card]");
    cards.forEach((card, index) => {
      const cardId = `${card.getAttribute("data-accordion-card")}_${index}`;
      const cardHeader = card.querySelector("[data-eta-trigger]");
      const cardContent = card.querySelector("[data-eta-receiver]");
      cardHeader.setAttribute("data-eta-trigger", `${cardId}`);
      cardContent.setAttribute("data-eta-receiver", `${cardId}`);
    });

    ETA.init({
      id,
      el: block,
      trigger: "[data-eta-trigger]",
      triggerAttr: "data-eta-trigger",
      receiver: "[data-eta-receiver]",
      receiverAttr: "data-eta-receiver",
      allowCollapseAll: true,
      activeSection: 0,
    });

    const acc = ETA.get(id);

    function toggleItems(items) {
      items.forEach((item) => {
        const currentCard = document.querySelector(
          `[data-eta-trigger="${item.id}"]`
        );

        if (currentCard) {
          const icon = currentCard.querySelector(".icon");
          icon?.classList[item.active ? "add" : "remove"]("is-rotated");
        }
      });
    }

    acc.on("onAfterOpen", (data) => {
      toggleItems(data.instance.dataset);
    });

    acc.on("onAfterClose", (data) => {
      toggleItems(data.instance.dataset);
    });
  });
});
